import React from 'react';

const About = () => {
  return (
    <section id="about" className="min-h-screen flex items-center bg-primary" aria-labelledby="about-title">
      <div className="container mx-auto px-4 md:px-6 py-16">
        <div className="text-center mb-16">
          <h2 id="about-title" className="text-4xl font-bold mb-4">About Us</h2>
          <p className="text-lightText max-w-2xl mx-auto">
            Our Mission
          </p>
          <p className="text-xl text-lightText max-w-3xl mx-auto mt-4">
            To seamlessly integrate intelligence into everyday life—making AI accessible and intuitive, supercharging human potential.
          </p>
        </div>
        
        <div className="max-w-5xl mx-auto">
          <h3 className="text-2xl font-bold mb-8 text-center">What Drives Us</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <article className="bg-cardBg p-8 rounded-lg">
              <h4 className="text-xl font-semibold mb-4 text-purple-500">Empowerment</h4>
              <p className="text-lightText">
                AI solutions crafted for simplicity, practicality, and daily usefulness.
              </p>
            </article>
            
            <article className="bg-cardBg p-8 rounded-lg">
              <h4 className="text-xl font-semibold mb-4 text-purple-500">Human-first</h4>
              <p className="text-lightText">
                Technology should amplify human potential, not complicate it.
              </p>
            </article>
            
            <article className="bg-cardBg p-8 rounded-lg">
              <h4 className="text-xl font-semibold mb-4 text-purple-500">Subtlety</h4>
              <p className="text-lightText">
                We bring AI into daily interactions gently and naturally, without overwhelming complexity.
              </p>
            </article>
          </div>
          
          <div className="text-center mt-16">
            <p className="text-lg text-lightText max-w-3xl mx-auto italic">
              At Humaniti.ai, we're not just building technology—we're enhancing everyday life, one experience at a time.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
